module.exports = __webpack_public_path__ + "static/media/dropdown-arrow.042c60f5.svg";